(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sensor-product-tabs')) {
  customElements.define('sensor-product-tabs', class extends HTMLElement {
    connectedCallback() {
      this.panels = Array.from(this.querySelectorAll('.tab-content'));
      this.controls = Array.from(this.querySelectorAll('button[data-panel]'));
      this.mobile = window.matchMedia('(max-width: 680px)');
      this.onClick = (event) => {
        const button = event.target.closest('button[data-panel]');
        if (!button || !this.contains(button)) return;
        const panel = this.panels.find((item) => item.id === button.dataset.panel);
        if (!panel) return;
        this.select(this.mobile.matches && !panel.hidden ? null : panel.id);
      };
      this.onModeChange = () => {
        const openPanel = this.panels.find((panel) => !panel.hidden);
        this.select(openPanel ? openPanel.id : this.mobile.matches ? null : this.panels[0]?.id);
      };
      this.addEventListener('click', this.onClick);
      this.mobile.addEventListener('change', this.onModeChange);
      this.onModeChange();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.mobile?.removeEventListener('change', this.onModeChange);
    }
    select(id) {
      this.panels.forEach((panel) => {
        const expanded = panel.id === id;
        panel.hidden = !expanded;
        panel.classList.toggle('current', expanded);
        const control = this.controls.find((button) => button.dataset.panel === panel.id &&
          Boolean(button.closest('.mobile-tabs')) === this.mobile.matches);
        if (control) panel.setAttribute('aria-labelledby', control.id);
      });
      this.controls.forEach((button) => {
        const expanded = button.dataset.panel === id;
        button.setAttribute('aria-expanded', String(expanded));
        const wrapper = button.closest('.tab-link, .mobile-tabs');
        wrapper.classList.toggle('current', expanded);
        if (wrapper.classList.contains('mobile-tabs')) wrapper.classList.toggle('arrow-active', expanded);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
